
<div class="PGQRCodeScanner bg-dark">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <video #videoElement></video>
</div>